<template>
	<div class='content'>
		
		<!-- map -->
		<div class='content__background sticky'>
      <div class='content_col' />
			<Map :dataIsReady='dataIsReady' :rawData='data' :resize='resize' :isMobile='isMobile' :lang='lang' />
      <div class='content_col content_col-100vh' />
		</div>

		<!-- content -->
    <div class='flex'>
      <div class='card card-first map__intro'>
        <div class='card__content'>
          <div class='card__text'>
            <span v-if="lang === 'en'">Here's one bridge that we built in Rwanda</span>
            <span v-else>Aquí hay un puente que construimos en Ruanda</span>
          </div>
        </div>
      </div>

      <div class='card card-movement map__movement'>
        <div class='card__content'>
          <div class='card__text'>
            <span v-if="lang === 'en'">And here are the people it connected</span>
            <span v-else>Y aquí están las personas a las que conectó</span>
          </div>
        </div>
      </div>

      <div class='spacer'></div>

      <div class='card card-red map__healthcare'>
        <div class='card__content card__content-icon'>
          <div class='flex'>
            <div class='card__icon card__icon-healthcare' />
            <p class='card__title card__title-icon'>
              <span v-if="lang === 'en'">Healthcare</span>
              <span v-else>Atención Médica</span>
            </p>
          </div>
          <p class='card__stats'>
            <span v-if="lang === 'en'">Trailbridges help local communities access healthcare. After a bridge is built, health clinics see an <span class='has-text-red has-text-bold'>18% increase</span> in patient visits.</span>
            <span v-else>Los puentes ayudan a las comunidades locales a acceder a la atención médica. Después de la construcción de un puente, las clínicas de salud ven un <span class='has-text-red has-text-bold'>aumento del 18%</span> en las visitas de pacientes.</span>
          </p>
        </div>
      </div>

      <div class='card card-green map__education'>
        <div class='card__content card__content-icon'>
          <div class='flex'>
            <div class='card__icon card__icon-education' />
            <p class='card__title card__title-icon'>
              <span v-if="lang === 'en'">Education</span>
              <span v-else>Educación</span>
            </p>
          </div>
          <p class='card__stats'>
            <span v-if="lang === 'en'">Trailbridges help children get to school. After a bridge is built, <span class='has-text-green has-text-bold'>12% more</span> children enroll in local schools.</span>
            <span v-else>Los puentes ayudan a los niños a llegar a la escuela. Después de la construcción de un puente, un <span class='has-text-green has-text-bold'>12% más</span> de niños se matriculan en las escuelas locales.</span>
          </p>
        </div>
      </div>

      <div class='card card-light-blue map__employment'>
        <div class='card__content card__content-icon'>
          <div class='flex'>
            <div class='card__icon card__icon-employment' />
            <p class='card__title card__title-icon'>
              <span v-if="lang === 'en'">Economies</span>
              <span v-else>Economias</span>
            </p>
          </div>
          <p class='card__stats'>
            <span v-if="lang === 'en'">Trailbridges help rural, isolated communities improve their livelihoods. After a bridge is built, average household income <span class='has-text-light-blue has-text-bold'>increases by 30%</span>.</span>
            <span v-else>Los puentes ayudan a las comunidades rurales y aisladas a mejorar sus medios de vida. Después de la construcción de un puente, el ingreso familiar promedio <span class='has-text-light-blue has-text-bold'>aumenta en un 30%</span>.</span>
          </p>
        </div>
      </div>

      <div class='card map__connection'>
        <div class='card__content'>
          <p class='card__text'>
            <span v-if="lang === 'en'">This <span class='has-text-red'>one bridge</span> connected over 27 villages and 7,000 people</span>
            <span v-else><span class='has-text-red'>Este puente</span> conectó más de 27 pueblos y 7.000 personas</span>
          </p>   
        </div>
      </div>

      <div class='card card-longer map__rwanda'>
        <div class='card__content'>
          <p class='card__text'>
            <span v-if="lang === 'en'">So far we've built over <span class='has-text-red'>{{ numBridgesRwanda }} bridges</span> in Rwanda</span>
            <span v-else>Hasta ahora hemos construido más de <span class='has-text-red'>{{ numBridgesRwanda }} puentes</span> en Ruanda</span>
          </p>
        </div>
      </div>

      <div class='card card-last map__world'>
        <div class='card__content'>
          <p class='card__text'>
            <span v-if="lang === 'en'">And <span class='has-text-red'>{{ numBridgesTotal }} bridges</span> worldwide</span>
            <span v-else>Y <span class='has-text-red'>{{ numBridgesTotal }} puentes</span> en todo el mundo</span>
          </p>
        </div>
      </div>

    </div>
	</div>
</template>

<script>
import Map from './Map.vue';

export default {
	components: {
		Map
	},
  props: {
    data: Object,
    dataIsReady: Boolean,
    resize: Number,
    lang: String,
    isMobile: Boolean
  },
  computed: {
    numBridgesRwanda() {
      return this.data.bridges.filter(b => { return b.country === 'Rwanda'}).length
    },
    numBridgesTotal() {
      return this.data.bridges.length
    }
  }
}

</script>